/**
 * @file Defines the {@link LANG_TEXTS} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Object for texts commonly used in new ui to be easily translated via object reference
  * @type {object}
  * @constant
  */

  const LANG_TEXTS = {

    winlines: 'You win by matching symbols on win lines. All symbols must be matched on consecutive reels from left to right. Only the highest win on each line will be paid. Malfunction voids all pays and plays. See game rules for more details.',
    winways:  'Wins are calculated by counting consecutive reels with matching symbols and multiplying by the total number of matching symbols on those reels.'

  }

  export { LANG_TEXTS }